module.exports = __webpack_public_path__ + "img/202503_01_sp.21feb8b1.jpg";